import { Base } from "src/app/models/base";
export class JobCandidate extends Base {
    jobId: number;
    candidateId: number;
}